import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { getCookie, getURLSegment, handleSwitchInputKeys } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Components
import Proctor from '../Modules/Proctor';
import Drawer from '../Drawer/Drawer';
import LoadMore from '../Common/LoadMore';
import Address from '../Map/Address';

// Dependencies
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown';
import { FeatureFlag } from "react-launch-darkly";

const LocateProctor = observer(class LocateProctor extends React.Component {
  constructor() {
    super();
    this.getBlackoutDates = this.getBlackoutDates.bind(this);
    this.getProctors = this.getProctors.bind(this);
    this.setProctorCategories = this.setProctorCategories.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.removeDistance = this.removeDistance.bind(this);
    this.toggleApproved = this.toggleApproved.bind(this);
    this.handleCategory = this.handleCategory.bind(this);
    this.removeCategory = this.removeCategory.bind(this);
    this.categoryName = this.categoryName.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
    this.resetFilters = this.resetFilters.bind(this);
  }

  componentWillMount() {
    const _this = this;
    const { SessionStore } = this.props.store;

    if(SessionStore.proctorTypeList.length === 0) {
      SessionStore.getProctorTypes();
    }

    this.state = {
      parents: [],
      filters: [],
      activeFilters: [],
      drawerOpen: false,
      drawerContent: null,
      distance: null,
      activeDistance: null,
      onlyApproved: false,
      sortBy: 'distance',
      proctorSid: null,
      proctorLocationSid: null,
      showProctorActions: false,
      showApprovalHistory: false,
      messageSid: null,
      query: null,
      location: null
    }

    const examSid = getURLSegment(this, 3);
    const sessionSid = getURLSegment(this, 5);

    if(sessionSid) {
      this.setState({
        showProctorActions: true
      });
    }

    // Set the categories
    if(SessionStore.userData.role.toLowerCase() === 'administrator') {
      this.props.store.ProctorStore.getProctorTypes();
      this.getProctors();
    } else {
      this.setProctorCategories(examSid, sessionSid);
    }

    if(examSid && sessionSid) {
      // Get session data
      this.props.store.EnrollmentStore.getExamSession(examSid, sessionSid, null, this.getBlackoutDates);
    }

    if(!sessionSid && SessionStore.userData.role.toLowerCase() === 'administrator') {
      this.setState({
        showApprovalHistory: true
      });
    }
  }

  componentWillUnmount() {
    this.props.store.ProctorStore.proctorsNext = null;
  }

  getBlackoutDates() {
    // Check for blackout dates
    const { BlackoutStore, EnrollmentStore } = this.props.store;
    const { examConfiguration } = EnrollmentStore.examSession;

    const query = {
      startDate: examConfiguration.examOpenDate,
      endDate: examConfiguration.examCloseDate
    };

    BlackoutStore.listBlackoutDates(query);
  }

  setProctorCategories(examSid, sessionSid) {
    let groupSid = getURLSegment(this, 10);

    // If the proctor categories aren’t already provided, get them
    if(this.state.filters.length === 0 && groupSid) {
      this.props.store.ProctorStore.getProctorGroupCategories(examSid, sessionSid, groupSid, this.getProctors, this);
    } else {
      this.getProctors();
    }
  }

  getProctors(component) {
    let _this = this;

    if(component) {
      _this = component;
    }

    const { searchForStudent, translation } = _this.props;
    const { ProctorStore, SessionStore } = _this.props.store;
    const { showDialog } = SessionStore;
    let sessionSid = getURLSegment(_this, 5);
    const proctorGroupSid = getURLSegment(_this, 10);

    if(!sessionSid && this.props.sessionSid) {
      sessionSid = this.props.sessionSid;
    }

    let query = '?';

    ProctorStore.resetProctors();

    _this.setState({
      filters: ProctorStore.proctorCategories
    });

    // Add sort and limit parameters
    query += `sortKeys=${_this.state.sortBy}&sortOrder=ASC&limit=25`

    // Add user id parameter
    let userData = {}

    if(SessionStore.hasSessionStorage) {
      userData = JSON.parse(sessionStorage.getItem('userData'));
    } else {
      userData = JSON.parse(getCookie('userData'));
    }

    query += `&userSid=${userData.userSid}`

    // Add category filters
    for(let i = 0; i < ProctorStore.proctorCategories.length; i++) {
      query += `&proctorSubcategories=${ProctorStore.proctorCategories[i]}`;
    }

    // Add proctor group sid
    if(proctorGroupSid) {
      query += `&proctorGroupSid=${proctorGroupSid}`;
    }

    // Make sure the profile has been loaded, then get the lat and lng
    if(!searchForStudent && SessionStore.userData.role.toLowerCase() !== 'administrator') {
      SessionStore.startLoading('Loading…', 'SearchCheckProfile');

      let checkProfile = setInterval(function(){
        if(typeof _this.props.store.SessionStore.profile.sid !== 'undefined') {
          const { ProctorStore } = _this.props.store;
          const { profile } = SessionStore;
          SessionStore.finishLoading('SearchCheckProfile');

          if(typeof profile.latitude !== 'undefined' && profile.latitude !== null) {
            // If the user has a lat and lng, search the proctors
            query += `&latitude=${profile.latitude}&longitude=${profile.longitude}`;

            // Add the session sid to the query
            if(sessionSid) {
              query += `&examSessionSid=${sessionSid}`
            }

            // Perform the search
            ProctorStore.searchProctors(query);

            // Store the query for later use
            _this.setState({
              query
            });
          } else {
            // Otherwise, let them know they need to complete their profile
            // and redirect them when they close the dialog
            showDialog(translation.location_missing);

            SessionStore.dialogCallback = function() {
              _this.props.routing.push({
                pathname: '/settings',
              });
            }
          }

          clearInterval(checkProfile);
        }
      }, 100);
    } else if(this.props.location) {
      // If performing a search for a student as another user
      // we already get the location from elsewhere
      const { location } = _this.props;

      if(location.latitude) {
        query += `&latitude=${location.latitude}&longitude=${location.longitude}`;
      }

      if(sessionSid) {
        query += `&examSessionSid=${sessionSid}`
      }

      // Perform the search
      ProctorStore.searchProctors(query);

      // Store the query for later use
      _this.setState({
        query
      });
    } else if(!this.props.location) {
      // Otherwise if we’re searching as an administator
      // search without a query
      let checkAdminProfile = setInterval(function(){
        if(typeof _this.props.store.SessionStore.profile.currencyCode !== 'undefined') {
          const { ProctorStore } = _this.props.store;

          SessionStore.finishLoading('SearchCheckProfile');
          ProctorStore.searchProctors('');

          clearInterval(checkAdminProfile);
        }
      }, 100);
    }
  }

  applyFilters(e) {
    if(e) {
      e.preventDefault();
    }

    let query = '?';
    const { searchForStudent, translation } = this.props;
    const { ProctorStore, SessionStore } = this.props.store;
    const { profile, showDialog } = SessionStore;
    let sessionSid = getURLSegment(this, 5);
    const proctorGroupSid = getURLSegment(this, 10);

    if(!sessionSid && this.props.sessionSid) {
      sessionSid = this.props.sessionSid;
    }

    // Add sort parameter
    query += `sortKeys=${this.state.sortBy}&sortOrder=ASC`

    // Add user id parameter
    let userData = {}

    if(SessionStore.hasSessionStorage) {
      userData = JSON.parse(sessionStorage.getItem('userData'));
    } else {
      userData = JSON.parse(getCookie('userData'));
    }

    query += `&userSid=${userData.userSid}`

    if(sessionSid) {
      query += `&examSessionSid=${sessionSid}`
    }

    if(this.state.distance) {
      query += `&maxTravelDistance=${this.state.distance}`;
    }

    if(this.state.filters.length > 0) {
      for(let i = 0; i < this.state.filters.length; i++) {
        query += `&proctorSubcategories=${this.state.filters[i]}`;
      }
    }

    if(proctorGroupSid) {
      query += `&proctorGroupSid=${proctorGroupSid}`;
    }

    if(this.state.onlyApproved) {
      query += '&onlyApproved=true'
    }

    if(!searchForStudent && SessionStore.userData.role.toLowerCase() !== 'administrator') {
      if(typeof profile.latitude !== 'undefined') {
        query += `&latitude=${profile.latitude}&longitude=${profile.longitude}`;
      } else {
        showDialog(translation.location_missing);
      }
    } else if(this.props.location) {
      // If performing a search for a student as another user
      // we already get the location from elsewhere
      const { location } = this.props;

      if(location.latitude) {
        query += `&latitude=${location.latitude}&longitude=${location.longitude}`;
      }
    }

    // If there’s a keyword provided, add that
    if(this.keyword && this.keyword.value) {
      query += `&keyword=*${this.keyword.value}*`;
    }

    // If a location has been provided, get the lat and lng
    if(this.state.location && this.state.location.lat && this.state.location.lng) {
      query += `&latitude=${this.state.location.lat}`;
      query += `&longitude=${this.state.location.lng}`;
    }

    if(this.state.filters === ProctorStore.proctorCategories) {
      this.setState({
        activeFilters: [],
        activeDistance: this.state.distance
      })
    } else {
      this.setState({
        activeFilters: this.state.filters,
        activeDistance: this.state.distance
      });
    }

    this.props.store.ProctorStore.searchProctors(query);
  }

  resetFilters() {
    const { ProctorStore } = this.props.store;

    this.setState({
      parents: [],
      filters: ProctorStore.proctorCategories || [],
      activeFilters: [],
      distance: null,
      activeDistance: null,
      sortBy: 'distance',
      onlyApproved: false,
      location: null
    }, function(){
      this.getProctors();
    });
  }

  handleInput() {
    let sortBy = 'distance';

    if(this.sortBy) {
      sortBy = this.sortBy.value || 'distance';
    }

    let distance = null;

    if(this.distance) {
      distance = parseInt(this.distance.value, 10)
    }

    this.setState({
      distance: distance,
      sortBy
    });

    const _this = this;

    setTimeout(function(){
      _this.applyFilters();
    });
  }

  removeDistance() {
    this.distance.value = '';

    this.setState({
      distance: null
    });

    const _this = this;

    setTimeout(function(){
      _this.applyFilters();
    })
  }

  toggleApproved() {
    this.setState({
      onlyApproved: !this.state.onlyApproved
    });

    const _this = this;

    setTimeout(function(){
      _this.applyFilters();
    });
  }

  addCat(val, subcats) {
    if(subcats.indexOf(val) < 0) {
      subcats.push(val);
    }
  }

  removeCat(val, subcats, apply) {
    for(let i = 0; i < subcats.length; i ++) {
      if(subcats[i] === val) {
        subcats.splice(i, 1);
      }
    }

    if(apply) {
      const _this = this;

      setTimeout(function(){
        _this.applyFilters();
      })
    }
  }

  handleCategory(e, isParent) {
    let subcats = [...this.state.activeFilters];
    let parentcats = [...this.state.parents];
    const thisVal = e.target.value;
    const _this = this;

    if(!isParent) {
      if(e.target.checked) {
        // Add the category to the array on check
        _this.addCat(thisVal, subcats)
      } else {
        // Remove the category from the array on uncheck
        _this.removeCat(thisVal, subcats);

        // Deselect the parent category
        const parentVal = e.target.parentElement.parentElement.previousSibling.previousSibling.value;
        _this.removeCat(parentVal, parentcats);
      }
    }

    // If it’s a parent category
    if(isParent) {
      if(e.target.checked) {
        // Select all children
        const childHolder = e.target.parentElement.querySelector('ul');
        const children = childHolder.querySelectorAll('input');

        for(let i = 0; i < children.length; i++) {
          _this.addCat(children[i].value, subcats);
        }

        _this.addCat(thisVal, parentcats);
      } else {
        // Otherwise, deselect all children
        const childHolder = e.target.parentElement.querySelector('ul');
        const children = childHolder.querySelectorAll('input');

        for(let i = 0; i < children.length; i++) {
          _this.removeCat(children[i].value, subcats);
        }

        _this.removeCat(thisVal, parentcats);
      }
    }

    // Make sure the results are at least filtered to the group’s allowed categories
    if(subcats.length === 0) {
      subcats = this.props.store.ProctorStore.proctorCategories;
    }

    this.setState({
      parents: parentcats,
      filters: subcats
    });

    setTimeout(function(){
      _this.applyFilters();
    })
  }

  removeCategory(sid, apply) {
    let subcats = [...this.state.filters];
    let parentcats = [...this.state.parents];

    // Remove sub category
    this.removeCat(sid, subcats, apply);

    // Remove parent category
    const thisEl = document.querySelector(`input[value=${sid}]`);
    const parentVal = thisEl.parentElement.parentElement.previousSibling.previousSibling.value;
    this.removeCat(parentVal, parentcats);

    // Make sure the results are at least filtered to the group’s allowed categories
    if(subcats.length === 0) {
      subcats = this.props.store.ProctorStore.proctorCategories;
    }

    this.setState({
      parents: parentcats,
      filters: subcats
    })
  }

  categoryName(catKey) {
    const { SessionStore } = this.props.store;
    let catName = null;

    // Set the category name if it’s a parent category
    SessionStore.proctorTypeList.filter(function(obj){
      return obj.sid === catKey
    }).map(
      (key) =>
      {
        catName = 'parent';
        return true;
      }
    )

    // If catName is still null, it’s a child category
    if(!catName) {
      SessionStore.proctorTypeList.map(
        (key) =>
        {
          key.subCategories.filter(function(obj){
            return obj.sid === catKey
          }).map(
            (subKey) =>
            {
              catName = subKey.title;
              return true;
            }
          )
          return true;
        }
      )
    }

    return catName;
  }

  renderRequestProctor() {
    const { translation } = this.props;
    const { SessionStore } = this.props.store;
    const { courseData, profile, userData } = SessionStore;

    return (
      <div
        className={`cta cta--fixed cta--inline ${this.state.hideCta ? 'hidden' : ''}`}
      >
        <span className="cta__subcopy">
          {translation.request.body}
        </span>

        &nbsp;

        <a
          className="btn--link"
          href={`https://smarterservices.typeform.com/to/iJvtxI?name=${profile.firstName} ${profile.lastName}&email=${profile.email}&course=${courseData.code}&institution=${userData.smarterProctoring.appInstallName}`}
          target="_blank"
        >
          {translation.request.button}
        </a>
      </div>
    );
  }

  render() {
    const { translation } = this.props;
    const { ProctorStore, SessionStore } = this.props.store;
    const { proctors, proctorCategories, proctorsNext, proctorsTotal } = ProctorStore;
    let sessionSid = getURLSegment(this, 5);

    if(!sessionSid && this.props.sessionSid) {
      sessionSid = this.props.sessionSid;
    }

    return (
      <main tabIndex="0" id="main-content" className="page">
        {!this.props.drawer &&
          <header className="page__header">
            <div className="wrap">
              <h1 className="page__title">{translation.page_title}</h1>
            </div>
          </header>
        }

        {this.props.drawer &&
          <header className="drawer__header">
            <div className="wrap">
              <h1 className="drawer__title">{translation.page_title}</h1>
            </div>
          </header>
        }

        <form className="filter" onSubmit={(e) => {this.applyFilters(e)}}>
          <div className="wrap">
            <fieldset className="filter__filters">
              <ul className="fields fields--inline">
                <li><legend>{translation.filter}:</legend></li>

                <li className="faux-select hidden">
                  <Dropdown ref="pagesDropdown">
                    <DropdownTrigger className="faux-select__selected">
                      {translation.proctor_type.label}
                    </DropdownTrigger>

                      <DropdownContent>
                      <ul className="faux-select__options dropdown__menu">
                        {SessionStore.proctorTypeList.map(
                          (key, i) =>
                          <li key={i} className={`separator filter-${key.sid} filter-empty`}>
                            <input type="checkbox" id={key.sid} className="checkbox-input" name="subcategories" value={key.sid} checked={this.state.parents.indexOf(key.sid) > -1} onChange={(e) => {this.handleCategory(e, true)}} />
                            <label htmlFor={key.sid} className="checkbox-label">{key.title}</label>

                            <ul>
                              {key.subCategories.map(
                                (subKey, j) => {
                                  if(proctorCategories.indexOf(subKey.sid) >= 0) {
                                    let parent = document.querySelector(`.filter-${key.sid}`);
                                    let dropdown = document.querySelector('.faux-select.hidden');

                                    if(parent) {
                                      parent.classList.remove('filter-empty');
                                      parent.className += ' filter-full';
                                    }

                                    if(dropdown) {
                                      dropdown.classList.remove('hidden');
                                    }

                                    return (
                                      <li
                                        key={j}
                                        className={j === 0 ? 'separator' : ''}
                                      >
                                        <input
                                          type="checkbox"
                                          id={subKey.sid}
                                          className="checkbox-input"
                                          name="subcategories"
                                          value={subKey.sid} checked={this.state.activeFilters.indexOf(subKey.sid) > -1}
                                          onChange={(e) => {this.handleCategory(e, false)}}
                                        />
                                        <label htmlFor={subKey.sid} className="checkbox-label">{subKey.title}</label>
                                      </li>
                                    )
                                  }

                                  return '';
                                }
                              )}
                            </ul>
                          </li>
                        )}
                      </ul>
                    </DropdownContent>
                  </Dropdown>
                </li>

                {sessionSid &&
                  <li>
                    <label className="select">
                      <select
                        ref={(input) => {this.distance = input}}
                        onChange={this.handleInput}
                      >
                        <option value="">{translation.distance.label}</option>
                        <option value={10}>10 {translation.distance.miles}</option>
                        <option value={25}>25 {translation.distance.miles}</option>
                        <option value={50}>50 {translation.distance.miles}</option>
                        <option value={100}>100 {translation.distance.miles}</option>
                      </select>
                    </label>
                  </li>
                }

                {!sessionSid &&
                  <li>
                    <label
                      className="meta"
                      htmlFor="filter-keyword"
                    >
                      {translation.keyword}
                    </label>

                    <input
                      type="text"
                      id="filter-keyword"
                      placeholder={translation.keyword}
                      ref={(input) => {this.keyword = input}}
                      onChange={e => {
                        if(this.keyword.value && this.keyword.value.length > 2) {
                          this.applyFilters(e);
                        }
                      }}
                    />
                  </li>
                }

                {!sessionSid &&
                  <li><legend>{translation.sorting}:</legend></li>
                }

                {!sessionSid &&
                  <li className="filter__lg">
                    <label
                      className="meta"
                      htmlFor="filter-location"
                    >
                      {translation.location}
                    </label>

                    <Address
                      parent={this}
                      onSelect={this.applyFilters}
                      {...this.props}
                    />
                  </li>
                }
              </ul>
            </fieldset>

            {sessionSid &&
              <fieldset>
                <input
                  type="checkbox"
                  id="filter-approved"
                  className="switch-input"
                  defaultChecked={this.state.onlyApproved}
                  onChange={this.toggleApproved}
                  onKeyDown={handleSwitchInputKeys}
                />
                <label className="switch-label" htmlFor="filter-approved"><span className="meta">{translation.approved}</span></label>
                <label className="switch-label--alt" htmlFor="filter-approved">{translation.approved}</label>
              </fieldset>
            }

            <button
              className="btn btn--outline"
              type="reset"
              onClick={this.resetFilters}
            >{translation.reset_button}</button>
          </div>
        </form>

        {!SessionStore.loading &&
          <div className="wrap wrap--md">
            {proctors.length > 0 &&
              <div className="active-filters">
                {proctors.length === 1 &&
                  <strong className="results">{proctorsTotal} {translation.results_singular}</strong>
                }

                {proctors.length !== 1 &&
                  <strong className="results">{proctorsTotal} {translation.results_plural}</strong>
                }

                <div className="tags">
                  <strong>{translation.selected}:</strong>

                  {this.state.activeDistance &&
                    <span className="tag tag--removable" onClick={() => this.removeDistance()}>
                      {this.state.activeDistance} {translation.distance.miles}
                    </span>
                  }

                  {this.state.activeFilters !== proctorCategories &&
                    this.state.activeFilters.map(
                      (key, i) =>
                      {
                        if(this.categoryName(key) !== 'parent') {
                          return (
                            <span key={i} className="tag tag--removable" onClick={() => this.removeCategory(key, true)}>
                              {this.categoryName(key)}
                            </span>
                          )
                        } else {
                          return '';
                        }
                      }
                    )
                  }
                </div>

                <div className="sort">
                  <strong>{translation.sorting}:</strong>

                  <label className="select">
                    <select
                      ref={(input) => {this.sortBy = input}}
                      onChange={this.handleInput}
                      defaultValue={this.state.sortBy}
                    >
                      <option value="distance">{translation.sorting_opts.distance}</option>
                      <option value="price">{translation.sorting_opts.price}</option>
                    </select>
                  </label>
                </div>
              </div>
            }

            <ul className="proctor-list">
              {proctors.map(
                (key, i) =>
                <li key={i} className="proctor-list__item">
                  <Proctor
                    proctor={key}
                    i={i}
                    parent={this}
                    showProctorActions={this.state.showProctorActions}
                    showApprovalHistory={this.state.showApprovalHistory}
                    {...this.props}
                  />
                </li>
              )}
            </ul>

            {!this.props.drawer &&
              <FeatureFlag
                flagKey="request-new-proctor"
                renderFeatureCallback={() => this.renderRequestProctor()}
              />
            }

            {proctorsNext &&
              <LoadMore
                clickFunction={this.loadMore}
                url={proctorsNext}
                group={proctors}
                text="Load more proctors"
                store={ProctorStore}
                {...this.props}
              />
            }

            {proctors.length === 0 &&
              <span className="no-results">{translation.no_results}</span>
            }
          </div>
        }

        {!this.props.drawer &&
          <Drawer
            content={this.state.drawerContent}
            isOpen={this.state.drawerOpen}
            parent={this}
            sessionRequest={true}
            examSid={getURLSegment(this, 3)}
            sessionSid={getURLSegment(this, 5)}
            examConfigurationSid={getURLSegment(this, 7)}
            proctorSid={this.state.proctorSid}
            toUserSid={this.state.proctorSid}
            contextType="examSid"
            contextId={getURLSegment(this, 3)}
            proctorLocationSid={this.state.proctorLocationSid}
            examSession={this.props.store.EnrollmentStore.examSession}
            messageSid={this.state.messageSid}
            searchPage={true}
            {...this.props}
          />
        }
      </main>
    );
  }
})

export default translate('LocateProctor')(LocateProctor);



// WEBPACK FOOTER //
// ./src/app/components/LocateProctor/LocateProctor.js